import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact"; 
import Feature from "./pages/Feature";
import Projects from "./pages/Projects";
import Team from "./pages/Team";

function App() {
  return (
    <BrowserRouter>
    <Routes>

  {/* Layout Wrapper */}
  <Route path="/" element={<Layout />}>

    {/* Home (default) */}
    <Route index element={<Home />} />

    {/* Pages */}
    <Route path="about" element={<About />} />
    <Route path="services" element={<Services />} />
    <Route path="contact" element={<Contact />} />
    <Route path="feature" element={<Feature />} />
    <Route path="projects" element={<Projects/>}/>
    <Route path="team" element={<Team/>}/>
    </Route>
    </Routes>
    </BrowserRouter>
  );
}

export default App;